import { Component, Input } from '@angular/core';

export type IconButtonType = 'RECORD' | 'PLATFORM' | 'FOOTER';

@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
})
export class IconButtonComponent {
  @Input()
  iconLigature: string;

  @Input()
  location: IconButtonType = 'RECORD';

  @Input()
  ariaHideLigature = false;

  @Input()
  tooltipText = '';
}
